<template>
  <v-container class="cmp-distribution-order-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <OrderDetails
        :selectedOrder="selectedOrder"
        @updated="onOrderDetailsUpdated"
        @mc_updated="onMainContactUpdated"
      />
      <glayout
        :tabs="orderSideWindowTabs"
        :options="optionButton"
        @optionClicked="onTabOptionClicked"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox
                :loading="selectedOrder.contact_loading"
                :title="$t('invoice_contact')"
              >
                <InvoiceContact
                  id="invoiceContact"
                  :invoiceContact="selectedOrder.contact"
                  :contactConfig="{
                    external_id:
                      selectedOrder.order_details_tab_summary &&
                      selectedOrder.order_details_tab_summary.order.order_id,
                    external_table: 'l_orders',
                    external_name: 'contact_id',
                    config_type: 'DistributionOrderInvoiceConfig',
                    key: 'order_id',
                  }"
                />
              </gbox>
              <!-- <gbox
                :loading="selectedOrder.order_details_tab_summary_loading"
                :title="$t('notes')"
                bc="var(--bc-note)"
              >
                <DBoxTextarea
                  :id="'notes'"
                  :value="
                    selectedOrder &&
                    selectedOrder.order_details_tab_summary &&
                    selectedOrder.order_details_tab_summary.order &&
                    selectedOrder.order_details_tab_summary.order.internal_notes
                  "
                  @blur="
                    (e) =>
                      onOrderDetailsUpdated({
                        name: 'internal_notes',
                        value: e.target.value,
                      })
                  "
                />
              </gbox> -->
              <gbox
                :loading="selectedOrder.order_details_tab_summary_loading"
                :title="$t('info')"
              >
                <DeliveryInfo
                  id="deliveryInfoDiscount"
                  @changed="onOrderDetailsUpdated"
                  :selectedOrder="selectedOrder"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :loading="selectedOrder.order_details_tab_summary_loading"
                :title="$t('delivery_address')"
                h="403"
              >
                <DeliveryAddress
                  id="deliveryAddress"
                  @changed="onOrderDetailsUpdated"
                  :selectedOrder="selectedOrder"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab
          id="backorders"
          v-if="!selectedOrder.isAccounted && selectedOrder.showBackorderTab"
        >
          <grow>
            <gcol>
              <gbox
                :loading="selectedOrder.order_details_tab_summary_loading"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedOrder &&
                      selectedOrder.get_backorders &&
                      selectedOrder.get_backorders.backorders &&
                      selectedOrder.get_backorders.backorders.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    max: 10,
                    min: 1,
                  })
                "
                :title="$t('backorders_string')"
              >
                <BackOrders
                  @add_backorders="onAddBackOrder"
                  @delete="onDeleteBackOrder"
                  @changed="onBackOrderUpdated"
                  :selectedOrder="selectedOrder"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="orderline" v-if="!selectedOrder.isAccounted">
          <template #header>
            <grow>
              <gcol>
                <div>
                  <OrderKVSummary :selectedOrder="selectedOrder" />
                </div>
              </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :loading="selectedOrder.order_details_tab_summary_loading"
                :title="$t('order_lines_string')"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedOrder &&
                      selectedOrder.order_details_tab_summary &&
                      selectedOrder.order_details_tab_summary.orderlines &&
                      selectedOrder.order_details_tab_summary.orderlines.length,
                    rowHeight: 52,
                    offset: NTOffsets.WithHeaderDBoxBottom + 110 + 12,
                    min: 0,
                    max: 10,
                  })
                "
              >
                <OrderLines
                  id="orderLine"
                  :selectedOrder="selectedOrder"
                  @autoBackOrder="onAutoBackOrder"
                  @changed="onOrderLineUpdated"
                  @delete="onDeleteOrderLine"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="packaging_shipping" v-if="!selectedOrder.isAccounted">
          <grow>
            <gcol>
              <gbox
                :loading="
                  selectedOrder.order_details_tab_summary_loading ||
                  selectedOrder.packing_orderlines_loading
                "
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedOrder &&
                      selectedOrder.packing_orderlines &&
                      selectedOrder.packing_orderlines.orderlines &&
                      selectedOrder.packing_orderlines.orderlines.length,
                    offset: NTOffsets.WithHeaderDBoxBottom + 200,
                    min: 0,
                    max: 10,
                  })
                "
                :title="$t('packaging_shipping')"
              >
                <PackagingShipping
                  id="shipping"
                  @changed="onPackageLineUpdated"
                  @changeShippingSummary="onShippingSummaryUpdated"
                  @autoBackOrder="onAutoBackOrder"
                  @packStatusChanged="onPackStatusChanged"
                  @delete="onDeleteOrderLine"
                  :selectedOrder="selectedOrder"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>

        <gtab id="summary">
          <grow>
            <gcol>
              <div style="margin-top: 16px; margin-bottom: 0px">
                <Summary
                  style="
                    background-color: #f7fff2;
                    padding: 10px 10px;
                    border-radius: 10px;
                  "
                  @changed="onOrderDetailsUpdated"
                  @reopen="onOrderReopenned"
                  :selectedOrder="selectedOrder"
                />
              </div>
            </gcol>
          </grow>
        </gtab>
      </glayout>
    </div>
    <ModalContainer :modalKey="'pickStatusModal'" :width="'small'">
      <PickStatusModal
        @changePickStatus="onChangePickStatus"
        @cancelled="onCancel"
      />
    </ModalContainer>

    <ModalContainer
      :modalKey="'accountDateModal'"
      :width="'small'"
      @cancelled="onCancel"
    >
      <AccountDateModal @cancelled="onCancel" @accounted="onAccountDone" />
    </ModalContainer>
    <ModalContainer
      :modalKey="'accountShippingCosts'"
      :width="'small2'"
      @cancelled="onCancel"
    >
      <AccountShippingCosts
        @cancelled="onCancel"
        @invoiced="onShippingCostsInvoiced"
        @shipping_costs_royalty_account="onShippingCostsRoyaltyAccount"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import BoxWidget from "@plugins/box-widget/box-widget";
import OrderDetails from "./order-details";
import DeliveryAddress from "./delivery-address";
import DeliveryInfo from "./delivery-info.vue";
import BackOrders from "./back-orders.vue";
import OrderLines from "./order-lines.vue";
import PackagingShipping from "./packaging-shipping.vue";
import PickStatusModal from "./pick-status-modal.vue";
import OrderKVSummary from "./order-kv-summary.vue";
import AccountDateModal from "./account-date-modal";
import AccountShippingCosts from "./account-shipping-costs.vue";

import DBoxTextarea from "../../../../dt-plugins/dbox-textarea/dbox-textarea";
import DBoxFiles from "../../../../dt-plugins/dbox-files/dbox-files";
import InvoiceContact from "@/dt-plugins/dbox-invoice-contact/dbox-invoice-contact.vue";
import ModalContainer from "@dtplugins/modal/modal-container";
import * as OrderActionTypes from "../../store/orders/types";
import { DistributionStoreNamespace as storeNS } from "../../store";
import { orderDetailsTabRoute } from "../../router/index";
import Summary from "./summary.vue";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { checkTabListPermission } from "../../../../router/guard/index";

import { distributionOrderListLDTRoutes } from "../../router/routes";
import { mapGetterObject, mapActionObject } from "../../../../store/global";
import { distributionOrderGetters } from "../../store/orders/getters";
import { distributionOrderActions } from "../../store/orders/actions";
import {
  closeModalRoute,
  createModalMixin,
  openModalRoute2,
} from "../../../../dt-plugins/modal/modal.mixin";
import {
  handleCloseTab,
  handleCloseTabRoute,
} from "../../../../dt-plugins/sidewindow/nav-tab";
import { handleFromRoute, routeWithFrom } from "../../../../utility/route";
import { OrderService } from "../../services/order.service";
import {
  confirmDelete,
  confirmError,
} from "../../../../dt-plugins/confirmation/confirmation-common";
import { showError } from "../../../../dt-plugins/notification/notification.service";
import { map, pick } from "ramda";
const moduleRoute = "distribution";
const submenuRoute = "orders";

export default {
  components: {
    OrderDetails,
    DeliveryAddress,
    DeliveryInfo,
    OrderLines,
    BackOrders,
    PackagingShipping,
    PickStatusModal,
    Summary,
    ModalContainer,
    DBoxTextarea,
    DBoxFiles,
    InvoiceContact,
    BoxWidget,
    OrderKVSummary,
    AccountDateModal,
    AccountShippingCosts,
  },
  data: function () {
    return {
      active: -1,
      selectedStatuses: new Set(),
      hideFees: true,
      displayMin: true,
      accountFiles: [],
    };
  },
  mixins: [
    createDTGridHost(),
    createModalMixin("pickStatusModal"),
    createModalMixin("accountDateModal"),
    createModalMixin("accountShippingCosts"),
  ],
  mounted: function () {},

  computed: {
    ...mapGetterObject(storeNS, distributionOrderGetters),
    order_id: function () {
      return this.$route.params.order_id;
    },
    order_title: function () {
      return `${this.order_id} ${this.selectedOrder?.order_details_tab_summary?.order?.order_type_name}`;
    },

    selectedOrder: function () {
      const distributionOrderDetails =
        (this.distributionOrderDetails || {})[this.order_id] || {};

      // Action Properties Of OrderDetails
      const order_details = distributionOrderDetails?.order_details;
      const order_details_tab_overview =
        distributionOrderDetails?.order_details_tab_overview;
      const order_details_tab_summary =
        distributionOrderDetails?.order_details_tab_summary;
      // console.log({'order-sidewindow.vue:334 order_details_tab_summary' : order_details_tab_summary});
      const get_delivery_address =
        distributionOrderDetails?.get_delivery_address;
      const get_backorders = distributionOrderDetails?.get_backorders;
      const order_details_tab_orderlines =
        distributionOrderDetails?.order_details_tab_orderlines;
      const get_orderlines = distributionOrderDetails?.get_orderlines;
      const order_details_tab_packing_shipping =
        distributionOrderDetails?.order_details_tab_packing_shipping;
      const packing_orderlines = distributionOrderDetails?.packing_orderlines;

      // const order = distributionOrderDetails.order || {};

      // const contact = distributionOrderDetails.contact || {};

      // const order_summary = distributionOrderDetails.order_summary || {};

      // const invoice = distributionOrderDetails.invoice || {};

      // const address_types = distributionOrderDetails.address_types || [];

      // const countries = distributionOrderDetails.countries || [];

      // const backorders = distributionOrderDetails.backorders || [];

      // const orderlines = distributionOrderDetails.orderlines || [];

      // const account = distributionOrderDetails.account || [];

      // const package_stock_accounts =
      //   distributionOrderDetails.package_stock_accounts || [];

      // const package_accounts = distributionOrderDetails.package_accounts || [];

      // const package_currency = distributionOrderDetails.package_currency || {};

      // const package_order_types =
      //   distributionOrderDetails.package_order_types || [];

      // const package_order_status =
      //   distributionOrderDetails.package_order_status || [];

      // const package_currencies =
      //   distributionOrderDetails.package_currencies || [];

      // const package_price_list =
      //   distributionOrderDetails.package_price_list || {};

      // const package_invoice_projects =
      //   distributionOrderDetails.package_invoice_projects || [];

      // const package_payment_methods =
      //   distributionOrderDetails.package_payment_methods || [];

      // const package_orderline_pack_status =
      //   distributionOrderDetails.package_orderline_pack_status || [];

      // const package_shipping_types =
      //   distributionOrderDetails.package_shipping_types || [];

      // const package_account = distributionOrderDetails.package_account || {};

      // const package_order = distributionOrderDetails.package_order || {};

      //  const invoice_contact = licenceAccountsDetails.invoice_contact || {};
      const order = order_details_tab_summary?.order;

      const discount_amount = +(
        +order_details_tab_summary?.orderObj?.order_value *
        ((order?.order_discount / 100) * -1)
      );
      const subtotal = +order_details_tab_summary?.orderObj?.order_value;
      const shipping_costs = +order?.shipping_costs;
      console.log({
        "order-sidewindow.vue:438 shipping_costs": shipping_costs,
      });

      const total_cost = subtotal + shipping_costs + discount_amount;

      const isAccounted = order?.accounted_flag == 1;
      console.log({ "order-sidewindow.vue:376 isAccounted": isAccounted });

      // if `accounted_flag=1` **AND** `order_type in (1,3,6,9)` display **Open Related Invoice** button

      const accounted = order?.accounted_flag;
      const invoiced =
        order_details_tab_summary?.shipping_status?.status == "invoiced";
      const shippingAccounted =
        order_details_tab_summary?.shipping_status?.status == "accounted";

      const invoicable = [1, 3, 6, 9].includes(+order?.order_type);
      const hasInvoice =
        accounted && order_details_tab_summary?.invoice?.invoice_id;

      // if `order_type in (2,4,5,10)` display **Account Shipping** button
      const shippingAccountable =
        [2, 4, 5, 10].includes(+order?.order_type) &&
        !invoiced &&
        !shippingAccounted;

      // const shippingAccount = [2, 4, 5, 10].includes(order?.order_type);

      const orderCurrency =
        order_details_tab_summary?.order?.currency_iso ||
        this.$store.getters.account.client.default_currency ||
        "EUR";

      const order_type = +order?.order_type;

      // l_orders.order_type IN (1,2,5,10) AS show_stock_in_tab_packing_shipping,
      // l_orders.order_type IN (3,4,6,7,8,9) AS hide_stock_in_tab_packing_shipping,
        
      // l_orders.order_type IN (1,2,5,10) AS show_status_in_tab_packing_shipping,
      // l_orders.order_type IN (3,4,6,7,8,9) AS hide_status_in_tab_packing_shipping,
        
      // l_orders.order_type IN (1,2,5) AS show_tab_backorder,
      // l_orders.order_type IN (3,4,6,7,8,9,10) AS hide_tab_backorder,
        
      // l_orders.order_type IN (1,2,5,10) AS show_button_auto_backorder,
      // l_orders.order_type IN (3,4,6,7,8,9) AS hide_button_auto_backorde,
        
      // l_orders.order_type IN (1,2,5,10) AS show_status_button_change_pickup_status,
      // l_orders.order_type IN (3,4,6,7,8,9) AS hide_button_change_pickup_status

      const showStockColumn = [1, 2, 5, 10].includes(order_type);
      const showStatusColumn = [1, 2, 5, 10].includes(order_type);
      const showBackorderTab = [1, 2, 5].includes(order_type);
      const backorderBuildCurrently = [1, 2, 5].includes(order_type);
      const packShipHideButtons = [3, 4, 6, 7, 8, 9].includes(order_type);

      const show_stock_in_tab_packing_shipping = [1, 2, 5, 10].includes(
        order_type
      );

      const show_status_in_tab_packing_shipping = [1, 2, 5, 10].includes(
        order_type
      );

      const show_tab_backorder = [1, 2, 5].includes(order_type);

      const show_button_auto_backorder = [1, 2, 5, 10].includes(order_type);

      const show_status_button_change_pickup_status = [1, 2, 5, 10].includes(
        order_type
      );

      const selectedOrderDeatails = {
        ...distributionOrderDetails,

        order_details,
        order_details_tab_overview,
        order_details_tab_summary,
        get_delivery_address,
        get_backorders,
        order_details_tab_orderlines,
        get_orderlines,
        order_details_tab_packing_shipping,
        packing_orderlines,

        discount_amount,
        subtotal,
        shipping_costs,
        total_cost,

        isAccounted,
        hasInvoice,
        shippingAccountable,
        invoiced,
        shippingAccounted,

        orderCurrency,

        showStockColumn,
        showStatusColumn,
        showBackorderTab,
        backorderBuildCurrently,
        packShipHideButtons,


        show_stock_in_tab_packing_shipping,
        show_status_in_tab_packing_shipping,
        show_tab_backorder,
        show_button_auto_backorder,
        show_status_button_change_pickup_status,

        // order,
        // contact,
        // order_summary,
        // address_types,
        // countries,
        // backorders,
        // orderlines,
        // account,
        // package_stock_accounts,
        // package_accounts,
        // package_currency,
        // package_order_types,
        // package_order_status,
        // package_currencies,
        // package_price_list,
        // package_invoice_projects,
        // package_payment_methods,
        // package_orderline_pack_status,
        // package_shipping_types,
        // package_account,
        // package_order,
        // invoice,
        //invoice_contact
      };
      console.log("selectedOrderDeatails", selectedOrderDeatails);
      return selectedOrderDeatails;
    },
    optionButton: function () {
      // console.log(
      //   this.selectedOrder?.order_details_tab_summary?.invoice,
      //   "this.selectedOrder?.order_details_tab_summary?.invoice"
      // );

      let conditionalButtons = [];

      if (this.selectedOrder?.order_details_tab_summary?.invoice != {}) {
        conditionalButtons = [
          {
            text: "Delete",
            value: "delete",
            error: true,
          },
        ];
      }

      return [
        {
          text: this.$t("documents_string"),
          value: "documents",
        },
        ...conditionalButtons,
      ];
    },
    orderSideWindowTabs: function () {
      return this.selectedOrder.isAccounted
        ? checkTabListPermission(moduleRoute, submenuRoute, [
            {
              route: "overview",
              value: this.$t("overview"),
              vgi_id: "invoice_contact",
            },
            {
              route: "summary",
              value: this.$t("tab_title_summary"),
              vgi_id: "tab_title_summary",
            },
          ])
        : checkTabListPermission(moduleRoute, submenuRoute, [
            {
              route: "overview",
              value: this.$t("overview"),
              vgi_id: "invoice_contact",
            },
            ...(this.selectedOrder.showBackorderTab
              ? [
                  {
                    route: "backorders",
                    value: this.$t("backorders"),
                    vgi_id: "backorders",
                  },
                ]
              : []),
            {
              route: "orderline",
              value: this.$t("orderline"),
              vgi_id: "orderline",
            },
            {
              route: "packaging_shipping",
              value: this.$t("packaging_shipping"),
              vgi_id: "packaging_shipping",
            },
            {
              route: "summary",
              value: this.$t("tab_title_summary"),
              vgi_id: "tab_title_summary",
            },
          ]);
    },
  },
  methods: {
    ...mapActionObject(storeNS, distributionOrderActions),
    routeMount: function () {},

    tabSelected: function (e) {
      this.$router.push({
        name: orderDetailsTabRoute,
        params: {
          account_id: this.$route.params.order_id,
          tab: this.orderSideWindowTabs[e].route,
        },
      });
    },
    scrollToTab: function (route) {},

    closeDistributionDetails: function (e) {
      this.$emit("closeAccountSidewindow", true);
    },

    onOrderDetailsUpdated: function ({ name, value }) {
      this[OrderActionTypes.DistributionOrderDetails.UPDATE.SINGLE]({
        order_id: this.selectedOrder.order.order_id,
        name,
        value,
        kVal: false,
      });
    },

    onBackOrderUpdated: function (payload) {
      this[OrderActionTypes.DistributionOrderBackOrder.UPDATE.SINGLE]({
        ...payload,
        order: this.selectedOrder?.order_details_tab_summary?.order,
      });
    },

    onDeleteBackOrder: function (payload) {
      this[OrderActionTypes.DistributionOrderBackOrder.DELETE.SINGLE]({
        ...payload,
      });
    },
    onOrderLineUpdated: function (payload) {
      this[OrderActionTypes.DistributionOrderOrderLine.UPDATE.SINGLE]({
        ...payload,
        order: this.selectedOrder?.order_details_tab_summary?.order,
      });
    },

    onDeleteOrderLine: async function (payload) {
      await this[OrderActionTypes.DistributionOrderOrderLine.DELETE.SINGLE]({
        item: payload,
        order: this.selectedOrder?.order_details_tab_summary?.order,
      });

      // Call Partial Fetch ODTS and packing orderlines
      this[OrderActionTypes.DistributionOrderDetails.FETCH.PARTIAL]({
        properties: ["order_details_tab_summary", "packing_orderlines"],
        order_id: this.order_id,
      });
    },
    onPackageLineUpdated: function (payload) {
      this[OrderActionTypes.DistributionPackageLine.UPDATE.SINGLE]({
        ...payload,
        order: this.selectedOrder?.order_details_tab_summary?.order,
      });
    },

    onShippingSummaryUpdated: function (payload) {
      this[OrderActionTypes.DistributionShippingSummary.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedOrder?.order_details_tab_summary,
      });
    },
    onChangePickStatus: function (payload) {
      const orderlines = this.selectedOrder?.packing_orderlines?.orderlines.map(
        (e) => {
          return {
            orderline_id: e.orderline_id,
          };
        }
      );

      this[OrderActionTypes.DistributionShippingSummary.UPDATE.MULTIPLE]({
        ...payload,
        order_id: this.order_id,
        orderlines: orderlines,
      });
      this.onCancel();
    },

    onAutoBackOrder: function () {
      console.log("onAutoBackOrder");
      console.log(map(
          pick([
            "orderline_id",
            "status",
            "product_id",
            "product_allowed_country_account_show",
            "account_stock_unpacked_unreserved",
            "order_qty",
          ]),
          this.selectedOrder?.packing_orderlines?.orderlines || []
        ))
      this[OrderActionTypes.DistributionShippingSummary.UPDATE.MULTIPLE]({
        orderlines: map(
          pick([
            "orderline_id",
            "status",
            "product_id",
            "product_allowed_country_account_show",
            "account_stock_unpacked_unreserved",
            "order_qty",
          ]),
          this.selectedOrder?.packing_orderlines?.orderlines || []
        ),
        order_id: this.order_id,
      });
    },
    onPackStatusChanged: function (payload) {
      console.log("onPackStatusChanged", payload);
      this[OrderActionTypes.DistributionPackageLine.FETCH.ALL]({
        order_id: this.order_id,
        status: payload,
      });
    },
    onTabOptionClicked: async function (value) {
      if (value == "documents") {
        openModalRoute2(this, "dtTemplateList", {
          external_id: this.order_id,
        });
      } else if (value == "delete") {
        const confirmationResult = await confirmDelete(
          this.$t("order"),
          this.order_title
        );

        if (confirmationResult == "OK") {
          console.log({
            "order-sidewindow.vue:661 this.order_id": this.order_id,
          });

          await this[OrderActionTypes.DistributionOrderList.DELETE.SINGLE]({
            order_id: this.order_id,
          });
          handleCloseTab(
            this.$store,
            {
              title: "Distribution",
              route: "distribution",
              tkey: "distribution",
              img: "static/icons/nav/distribution.svg",
            },
            {
              primaryKey: "order_id",
              route: "orders",
              title: "Orders",
              DetailsAction: OrderActionTypes.DistributionOrderDetails,
            },
            {
              full_title: this.selectedOrder.order.order_id,
              route: this.selectedOrder.order.order_id,
              title: this.selectedOrder.order.order_id,
            }
          );
          handleFromRoute(this, () => {
            this.$router.push({
              name: distributionOrderListLDTRoutes.names.list,
            });
          });
        }
      }
    },

    onCancel: function () {
      closeModalRoute(this);
    },
    onAddBackOrder: async function (payload) {
      // console.log(payload);
      await this[OrderActionTypes.DistributionOrderBackOrder.UPDATE.MULTIPLE]({
        ...payload,
      });
      this.refetchODTSPO();
    },

    onMainContactUpdated: function (e) {},
    refetch: function () {
      this[OrderActionTypes.DistributionOrderDetails.FETCH.SINGLE]({
        order: {
          order_id: this.order_id,
        },
        flag: true,
        reload: true,
      });
    },
    // Refetch order_details_tab_summary
    refetchODTS() {
      this[OrderActionTypes.DistributionOrderDetails.FETCH.PARTIAL]({
        properties: ["order_details_tab_summary"],
        order_id: this.order_id,
      });
    },
    // Refetch both order_details_tab_summary and packing_orderlines
    refetchODTSPO() {
      this[OrderActionTypes.DistributionOrderDetails.FETCH.PARTIAL]({
        properties: ["order_details_tab_summary", "packing_orderlines"],
        order_id: this.order_id,
      });
    },
    async onOrderReopenned() {
      const confirmatinoResult = await confirmDelete(
        "",
        ``,
        "Are you sure you want to reopen this order"
      );
      if (confirmatinoResult == "OK") {
        const reopenData = await OrderService.reopen_order(this.order_id);
        if (reopenData.account_invoice.type == "invoice") {
          confirmError(this.$t("cancel_rel_inv"));
        } else {
          await this.refetch();
        }
      }
    },
    onAccountDone() {
      this.refetch();
    },
    onShippingCostsInvoiced(invoiceData) {
      this.onCancel();

      if (invoiceData?.invoice_id) {
        this.refetch();

        routeWithFrom(this, {
          name: `invoices/invoice_id/tab`,
          params: {
            invoice_id: invoiceData?.invoice_id,
            tab: "overview",
          },
        });
      } else {
        showError("Something went wrong");
      }
    },
    onShippingCostsRoyaltyAccount() {
      this.onCancel();

      this.refetchODTS();
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distribution-order-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 223px);
  }
  .dt-box-header {
    color: #ff6400;
    border-bottom: 1px solid #ff6400;
  }
}
</style>
